<div *ngIf="visible"
  style="position:fixed; top:0; left:0; width:100vw; height:100vh; z-index:999999;
    display:flex; align-items:center; justify-content:center; font-family:sans-serif;">

  <!-- Backdrop -->
  <div (click)="close()"
    style="position:absolute; top:0; left:0; width:100%; height:100%; background:rgba(0,0,0,0.5);"></div>

  <!-- Dialog -->
  <div style="position:relative; z-index:1; background:#fff; border-radius:16px;
    box-shadow:0 25px 50px rgba(0,0,0,0.25); width:90vw; max-width:420px; padding:32px 24px; text-align:center;">

    <!-- Icon circle -->
    <div style="width:72px; height:72px; border-radius:50%; margin:0 auto 20px;
      display:flex; align-items:center; justify-content:center;"
      [style.background]="icon === 'error' ? '#FEE2E2' : (icon === 'warning' ? '#FEF3C7' : '#D1FAE5')">

      <!-- Error X -->
      <svg *ngIf="icon === 'error'" width="40" height="40" viewBox="0 0 24 24" fill="none"
        stroke="#EF4444" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="15" y1="9" x2="9" y2="15" />
        <line x1="9" y1="9" x2="15" y2="15" />
      </svg>

      <!-- Warning triangle -->
      <svg *ngIf="icon === 'warning'" width="40" height="40" viewBox="0 0 24 24" fill="none"
        stroke="#F59E0B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
        <line x1="12" y1="9" x2="12" y2="13" />
        <line x1="12" y1="17" x2="12.01" y2="17" />
      </svg>

      <!-- Success check -->
      <svg *ngIf="icon === 'success'" width="40" height="40" viewBox="0 0 24 24" fill="none"
        stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
    </div>

    <!-- Title -->
    <h3 style="font-size:20px; font-weight:700; color:#111827; margin:0 0 8px; line-height:1.3;">
      {{ title }}
    </h3>

    <!-- Message -->
    <p style="font-size:15px; color:#6B7280; margin:0 0 28px; line-height:1.5;">
      {{ message }}
    </p>

    <!-- OK button -->
    <button (click)="close()"
      style="background:#8B1A1A; color:#fff; border:none; padding:12px 48px; border-radius:8px;
        font-size:15px; font-weight:700; cursor:pointer; letter-spacing:0.5px;
        transition:background 0.2s;"
      onmouseover="this.style.background='#6d1414'"
      onmouseout="this.style.background='#8B1A1A'">
      OK
    </button>
  </div>
</div>
